import profileDefault from "@/assets/profile-default.json";
import { deepCopy } from "@/utils";

const state = {
  name: "Mosaic * American train",
  fileName: "AM",
  version: "r2",
  data: deepCopy(profileDefault),
  default: deepCopy(profileDefault),
  lightIndex: 4,
};

const actions = {
  setVersion({ commit }, version) {
    commit("SET_VERSION", version);
  },
  setFileName({ commit }, fileName) {
    commit("SET_FILE_NAME", fileName);
  },
  setData({ commit }, data) {
    commit("SET_DATA", data);
  },
  setLightIndex({ commit }, index) {
    commit("SET_LIGHT_INDEX", index);
    return;
  },
};

const mutations = {
  SET_VERSION: (state, version) => {
    state.version = version;
  },
  SET_FILE_NAME: (state, fileName) => {
    state.fileName = fileName;
  },
  SET_DATA: (state, data) => {
    state.data = data;
  },
  SET_LIGHT_INDEX: (state, index) => {
    state.lightIndex = index;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
